import { render, staticRenderFns } from "./TabletToolUI.vue?vue&type=template&id=19185ae8&scoped=true&"
import script from "./TabletToolUI.vue?vue&type=script&lang=js&"
export * from "./TabletToolUI.vue?vue&type=script&lang=js&"
import style0 from "./TabletToolUI.vue?vue&type=style&index=0&id=19185ae8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19185ae8",
  null
  
)

export default component.exports